import { Dispatch, SetStateAction, useEffect } from "react";

import { EnrichmentFilterConfig } from "../../ListEditDetails";
import { CountrySelection, IcpPosition } from "../../enum/icp.enum";

type Prio = "first" | "second" | "third";

/**
 * Keeps `titleFilters[prio].error` in sync with whether the selected position/location option still
 * needs required input. Extracted verbatim from DefineIcp so that component stays within the
 * file-length budget.
 */
export function useIcpValidation(
	titleFilters: EnrichmentFilterConfig | undefined,
	setTitleFilters: Dispatch<SetStateAction<EnrichmentFilterConfig | undefined>>,
	prio: Prio
) {
	useEffect(() => {
		if (
			titleFilters?.[prio]?.position === IcpPosition.CUSTOM &&
			!titleFilters?.[prio]?.title &&
			!titleFilters?.[prio]?.error
		) {
			setTitleFilters({
				...titleFilters,
				[prio]: {
					...titleFilters?.[prio],
					error: true,
				},
			});

			return;
		} else if (
			titleFilters?.[prio]?.position === IcpPosition.PERSONA_SEGMENT &&
			!titleFilters?.[prio]?.personaCategoryId &&
			!titleFilters?.[prio]?.error
		) {
			setTitleFilters({
				...titleFilters,
				[prio]: {
					...titleFilters?.[prio],
					error: true,
				},
			});

			return;
		} else if (
			titleFilters?.[prio]?.position === IcpPosition.DEPARTMENT_SENIORITY &&
			(!titleFilters?.[prio]?.department || titleFilters?.[prio]?.department?.length === 0) &&
			(!titleFilters?.[prio]?.seniority || titleFilters?.[prio]?.seniority?.length === 0) &&
			!titleFilters?.[prio]?.error
		) {
			setTitleFilters({
				...titleFilters,
				[prio]: {
					...titleFilters?.[prio],
					error: true,
				},
			});

			return;
		} else if (
			titleFilters?.[prio]?.countrySelection === CountrySelection.CUSTOM &&
			(!titleFilters?.[prio]?.countries || titleFilters?.[prio]?.countries?.length === 0) &&
			(!titleFilters?.[prio]?.regions || titleFilters?.[prio]?.regions?.length === 0) &&
			!titleFilters?.[prio]?.error
		) {
			setTitleFilters({
				...titleFilters,
				[prio]: {
					...titleFilters?.[prio],
					error: true,
				},
			});

			return;
		}

		let hasErrors = false;

		if (titleFilters?.[prio]?.position === IcpPosition.CUSTOM && !titleFilters?.[prio]?.title) {
			hasErrors = true;
		}

		if (
			titleFilters?.[prio]?.position === IcpPosition.PERSONA_SEGMENT &&
			!titleFilters?.[prio]?.personaCategoryId
		) {
			hasErrors = true;
		}

		if (
			titleFilters?.[prio]?.position === IcpPosition.DEPARTMENT_SENIORITY &&
			(!titleFilters?.[prio]?.department || titleFilters?.[prio]?.department?.length === 0) &&
			(!titleFilters?.[prio]?.seniority || titleFilters?.[prio]?.seniority?.length === 0)
		) {
			hasErrors = true;
		}

		if (
			titleFilters?.[prio]?.countrySelection === CountrySelection.CUSTOM &&
			(!titleFilters?.[prio]?.countries || titleFilters?.[prio]?.countries?.length === 0) &&
			(!titleFilters?.[prio]?.regions || titleFilters?.[prio]?.regions?.length === 0)
		) {
			hasErrors = true;
		}

		if (!hasErrors && titleFilters?.[prio]?.error) {
			setTitleFilters({ ...titleFilters, [prio]: { ...titleFilters?.[prio], error: false } });
		}
	}, [titleFilters]);
}
